export const commonEnv = {
  production: false,
  isPendo: false,
  isLocal: true,
  agGridLicenseKey:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-083950}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cloudmed}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{3}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_September_2026}____[v3]_[01]_MTc4OTQyNjgwMDAwMA==10f7ccce1092ce94b9cf2d20cf88b07e',
  auth0Config: {
    domain: 'auth.dev.cloudmed.com',
    clientId: 'zpUAjX8FGZZ6cFnX1niVL9ahWw5wtCbY',
    audience: 'dev.cloudmed',
    redirectUri: window.location.origin + '/callback',
    useRefreshTokens: true,
    httpInterceptor: {
      allowedList: [
        'https://cmedevpricingcontractapi.azurewebsites.net/api/*',
        'https://cmedevpricingphysiciancontractsapi.azurewebsites.net/api/*',
        'https://cmedevpricingworkflowapi.azurewebsites.net/api/*',
        'https://cmedevpricingglobalapi.azurewebsites.net/*',
        'https://cmedevwkdradminapi.azurewebsites.net/*',
        'https://ps-payer-rules-api.dev.cloudmed.com/*',
        'https://usermanagementapi.dev.cloudmed.com/*',
      ],
    },
  },
  api: {
    contractsApi: 'https://cmedevpricingcontractapi.azurewebsites.net/api',
    payerRulesApiBaseURL: 'https://ps-payer-rules-api.dev.cloudmed.com/api/',
    physicianContractsApi: 'https://cmedevpricingphysiciancontractsapi.azurewebsites.net/api/contract',
    pricingWorkflowApi: 'https://cmedevpricingworkflowapi.azurewebsites.net/api',
    riUserManagementBaseURL: 'https://usermanagementapi.dev.cloudmed.com/',
  },
  uiUrl: {
    accountInfoURL: 'https://app.dev.cloudmed.com/account-info?id=',
    adminUrl: 'https://admin.dev.cloudmed.com/',
    contractsUiUrl: 'https://contracts.dev.cloudmed.com',
    payerReimbursementConfigUrl:
      'https://payerreimbursementconfigs.ppe.cloudmed.com/payer-reimbursement-configurations/edit?id=',
    pricingUiBaseURL: 'https://pricing.dev.cloudmed.com',
    contractRepositoryURL: 'https://contractrepository.dev.cloudmed.com/Physician',
  },
  applicationId: 54,
  applicationName: 'Pricing Service',
  applicationGroupName: 'Pricing Service',
};
